import react from 'react';

function AQuienAyudo() {
    return (
        <div className='container m-auto my-12'>
            <h1 className='text-2xl text-center font-times mx-5'>
               <strong>¿A Quién Ayudo?</strong>
            </h1>
            <div className='flex items-center justify-center my-12'>
                <p className='text-xl text-justify font-times mx-5'>
                    Este espacio está dirigido a personas, emprendedores, líderes y empresarios que sienten que están llamados a crecer, evolucionar y alcanzar un nivel más alto de desarrollo personal y profesional. Acompañamos a quienes entienden que el verdadero cambio comienza en la mentalidad y que el crecimiento interior es la base para construir una vida, un liderazgo y proyectos con propósito.
                </p>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-12 mx-8 h-auto'>

                <div className='flex flex-col items-center justify-center my-8'>
                    <p className='text-xl font-times mx-5'>
                        Trabajamos con personas que:
                    </p>
                    <ul className='text-justify mx-5'>
                        <li className='text-xl font-times text-justify'>•	Desean fortalecer su mentalidad y desarrollar una visión más clara para su vida</li>
                        <li className='text-xl font-times text-justify'>•	Buscan descubrir y vivir con mayor propósito</li>
                        <li className='text-xl font-times text-justify'>•	Están dispuestas a romper creencias limitantes y expandir su forma de pensar</li>
                        <li className='text-xl font-times text-justify'>•	Quieren desarrollar mayor confianza, disciplina y liderazgo personal</li>
                        <li className='text-xl font-times text-justify'>•	Están comprometidas con su crecimiento personal, espiritual y emocional</li>
                    </ul>
                </div>

                <div className='flex flex-col items-center justify-center my-8'>
                    <p className='text-xl text-justify font-times mx-5'>
                        También acompañamos a <strong>emprendedores, líderes y empresas</strong> que desean:
                    </p>
                    <ul className='text-justify mx-5'>
                        <li className='text-xl text-justify font-times'>•	Desarrollar liderazgo consciente dentro de sus equipos</li>
                        <li className='text-xl text-justify font-times'>•	Fortalecer la mentalidad de crecimiento en su organización</li>
                        <li className='text-xl text-justify font-times'>•	Mejorar la claridad estratégica y la toma de decisiones</li>
                        <li className='text-xl text-justify font-times'>•	Impulsar culturas empresariales basadas en propósito, responsabilidad y crecimiento</li>
                    </ul>
                </div>

            </div>

            <div className='flex items-center justify-center my-12'>
                <p className='text-xl text-justify font-times mx-5'>
                    Creemos firmemente que <strong>cuando una persona transforma su mentalidad, transforma sus resultados</strong>, y cuando un líder evoluciona, también evoluciona su equipo, su empresa y su impacto. Si sientes que estás listo para crecer, expandir tu visión y descubrir el poder que existe dentro de ti, este espacio es para ti.
                </p>
            </div>

            <div className='flex items-center justify-center my-12'>
                <h1 className='text-2xl text-justify font-times mx-5'>
                    <strong>El Éxito Comienza El Día Que Decides Trabajar Primero En Ti Mismo.</strong>
                </h1>
            </div>

        </div>
    )
}

export default AQuienAyudo;